import { TFooterPageType } from '@helpers/constants/footerSections';
import { TSections } from '@services/datocms/visual-blocks';

export type TGeneralFooterItem = {
  name: string;
  url: string;
};

export type TFooterSectionsContent = {
  id: string;
  active: boolean;
  pageType: TFooterPageType;
  sectionsContent: Nullable<{
    sections: TSections;
  }>;
};

export type TSectionFooterPaymentMethods = {
  americanExpress?: boolean;
  boleto?: boolean;
  cartoes?: boolean;
  dinners?: boolean;
  elo?: boolean;
  hipercard?: boolean;
  pix?: boolean;
  visa?: boolean;
  mastercard?: boolean;
  carneDigital?: boolean;
  nuPay?: boolean;
};

type TSectionFooterTeleshoppingItem = {
  phoneTitle: string;
  phoneContact: string;
  onlyText: string;
};

type TSectionFooterSiteMap = {
  name: string;
  url: string;
};

type TSectionFooterSiteMapPage = {
  title: string;
  links: [
    {
      title: string;
      links: [
        {
          title: string;
          link: {
            url: string;
          };
        },
      ];
    },
  ];
  footerText: string;
  footerLink: {
    url: string;
    name: string;
  };
};

export type TSectionFooterData = {
  sectionFooter: {
    footerPaymentMethods?: TSectionFooterPaymentMethods[];
    footerInstitutional?: TGeneralFooterItem[];
    footerHowToWork?: TGeneralFooterItem[];
    footerAttendanceV2?: TGeneralFooterItem[];
    footerTeleshoppingV2?: TSectionFooterTeleshoppingItem[];
    footerSiteMap?: TSectionFooterSiteMap[];
    privacyPolicy?: string;
    socialReason?: string;
    terms?: string;
    siteMapPage?: TSectionFooterSiteMapPage[];
    sections?: TFooterSectionsContent[];
  };
};

export const parseSectionFooter = ({ sectionFooter }: any) => {
  const { footerSiteMap = [] } = sectionFooter;
  const siteMapParsedV2 = footerSiteMap?.map(({ name, link: { url } }) => ({ name, url }));

  return {
    ...sectionFooter,
    footerSiteMap: [...siteMapParsedV2],
  };
};
